import { Link, Navigate, NavLink, Outlet, useLocation } from 'react-router-dom'
import type { Me } from '../api/types'
import { useMe, useSignOut } from '../hooks/useMe'
import { WorkspaceProvider } from '../hooks/useWorkspace'
import { AccountMenu } from './AccountMenu'
import { WorkspaceSwitcher } from './WorkspaceSwitcher'
import { ErrorNote, LoadingBlock, Logo } from './ui'

/** Layout for signed-in pages. Sends anonymous visitors to /sign-in. */
export function Shell() {
  const me = useMe()
  const location = useLocation()
  if (me.isPending) return <div className="page-center"><LoadingBlock /></div>
  if (me.isError) return <div className="page-center"><ErrorNote error={me.error} /></div>
  if (!me.data.authenticated || !me.data.user) {
    const returnTo = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?return_to=${returnTo}`} replace />
  }
  return (
    <WorkspaceProvider workspaces={me.data.workspaces}>
      <div className="app">
        <Header me={me.data} />
        <main className="main">
          <Outlet />
        </main>
      </div>
    </WorkspaceProvider>
  )
}

function Header({ me }: { me: Me }) {
  const signOut = useSignOut()
  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/studio" className="brand">
          <Logo /> indiefuture
        </Link>
        <WorkspaceSwitcher />
        <nav className="nav">
          <NavLink to="/studio" end>Shows</NavLink>
          <NavLink to="/studio/workspace">Workspace</NavLink>
          <NavLink to="/studio/billing">Credits</NavLink>
          {me.is_admin && <NavLink to="/studio/admin">Admin</NavLink>}
        </nav>
        <AccountMenu email={me.user?.email ?? ''} onSignOut={() => signOut.mutate()} signingOut={signOut.isPending} />
      </div>
    </header>
  )
}
